var _defs, _path, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrations02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d7bbff;\n      }\n\n      .st1 {\n        fill: #fbd072;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #efe6ff;\n      }\n\n      .st4 {\n        fill: #8c8ce8;\n      }\n\n      .st5 {\n        fill: none;\n      }\n\n      .st6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st7 {\n        fill: #4d2384;\n      }\n\n      .st8 {\n        fill: #28287f;\n      }\n\n      .st9 {\n        fill: #351863;\n      }\n\n      .st10 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "273.86 295.31 82.67 254.92 92.85 226.93 284.53 267.41 273.86 295.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411.72,197.03l-24.71,3.81c-2.77.43-5.07-1.46-5.15-4.23l-.4-14.4c-.08-2.87,2.15-5.56,4.99-6l25.32-3.91c2.83-.44,5.12,1.56,5.09,4.44l-.1,14.48c-.02,2.79-2.28,5.38-5.04,5.81Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.23,162.07c-46.32,2.09-86.87,42.84-90.83,88.7-2.47,28.65,8.37,58.03,30.91,76.31,23.59,19.14,57,18.23,84.67,10.63,27.59-7.59,51.45-28.66,61.43-55.6,16.53-44.6-6.32-96.41-50.46-113.94-11.31-4.49-23.57-6.64-35.73-6.09Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 335.15,
    y: 350.2,
    width: 11.84,
    height: 11.84,
    rx: 2.68,
    ry: 2.68,
    transform: "translate(-151.92 345.48) rotate(-45)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M238.29,358.34l-168.87-35.67c-5.85-1.24-8.94-6.8-6.89-12.43l32.39-89.01c2.08-5.73,8.57-9.36,14.48-8.11l170.55,36.02c5.91,1.25,8.93,6.89,6.75,12.6l-33.93,88.68c-2.15,5.61-8.63,9.15-14.48,7.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "273.86 295.31 82.67 254.92 92.85 226.93 284.53 267.41 273.86 295.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 134.43,
    y: 255.3,
    width: 46.81,
    height: 1.02,
    transform: "translate(-134.32 185.12) rotate(-44.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 173,
    y: 263.45,
    width: 46.89,
    height: 1.02,
    transform: "translate(-128.78 213.97) rotate(-44.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 179.34,
    y: 264.79,
    width: 46.9,
    height: 1.02,
    transform: "translate(-127.89 218.82) rotate(-44.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 219.2,
    y: 273.22,
    width: 46.97,
    height: 1.02,
    transform: "translate(-122.25 248.25) rotate(-44.45)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.48,319.65l-49.65-10.49c-5.06-1.07-7.69-5.88-5.87-10.75h0c1.82-4.88,7.41-7.96,12.48-6.89l49.73,10.5c5.07,1.07,7.67,5.89,5.82,10.76h0c-1.85,4.87-7.45,7.94-12.51,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.26,329.47c-1.43-.3-143.14-30.23-143.53-30.32l.21-1c.39.08,142.1,30.01,143.53,30.32l-.21,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.99,317.2c-.49-.1-48.9-10.33-49.07-10.36l.21-1c.13.03,47.07,9.94,49.07,10.36l-.21,1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M426.94,253.81l-170.86,26.38c-5.92.91-10.78-3.2-10.86-9.2l-1.17-94.87c-.08-6.1,4.71-11.81,10.69-12.73l172.56-26.64c5.98-.92,10.81,3.29,10.79,9.41l-.39,95.11c-.02,6.02-4.85,11.63-10.77,12.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.17,256.22l-16,2.47,1.77-21.44,15.45-2.39c5.51-.85,9.79,3.1,9.56,8.92h0c-.24,5.94-5.06,11.55-10.77,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.44,258.64l-11.7,1.81c-2.17.34-4.07-1.48-3.84-3.66l1.57-14.64c.16-1.51,1.32-2.72,2.81-2.95l12.91-1.99c5.51-.85,9.67,3.12,9.29,8.96h0c-.39,5.96-5.34,11.59-11.05,12.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.72,197.03l-24.71,3.81c-2.77.43-5.07-1.46-5.15-4.23l-.4-14.4c-.08-2.87,2.15-5.56,4.99-6l25.32-3.91c2.83-.44,5.12,1.56,5.09,4.44l-.1,14.48c-.02,2.79-2.28,5.38-5.04,5.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 379.72,
    y: 186.43,
    width: 36.59,
    height: 1.02,
    transform: "translate(33.86 433.43) rotate(-59.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 391.34,
    y: 185.1,
    width: 36.59,
    height: 1.02,
    transform: "translate(40.68 442.77) rotate(-59.25)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M379.72,196.35c-1.4,0-2.71-.46-3.76-1.33-1.29-1.07-2.04-2.64-2.1-4.42-.13-3.66,2.73-7.1,6.37-7.66l9.44-1.46c1.79-.28,3.49.17,4.79,1.27,1.29,1.09,2.02,2.69,2.04,4.49.05,3.63-2.83,7.03-6.43,7.58l-9.32,1.44c-.34.05-.69.08-1.02.08ZM390.69,182.43c-.28,0-.57.02-.86.07l-9.44,1.46c-3.14.49-5.61,3.45-5.5,6.61.05,1.48.67,2.78,1.73,3.66,1.07.89,2.48,1.25,3.97,1.02l9.32-1.44c3.11-.48,5.6-3.42,5.56-6.56-.02-1.5-.62-2.82-1.68-3.72-.86-.73-1.94-1.11-3.11-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M407.67,192.04c-1.39,0-2.69-.46-3.71-1.33-1.27-1.08-1.97-2.66-1.99-4.45-.03-3.67,2.91-7.11,6.54-7.68l9.44-1.46c1.79-.28,3.47.18,4.73,1.27,1.27,1.1,1.95,2.71,1.92,4.53-.05,3.64-3.01,7.04-6.6,7.6l-9.32,1.44c-.34.05-.68.08-1.01.08ZM418.97,178.07c-.28,0-.57.02-.86.07l-9.44,1.46c-3.15.49-5.7,3.47-5.67,6.66.01,1.49.59,2.8,1.63,3.68,1.04.89,2.43,1.25,3.91,1.02l9.32-1.44c3.12-.48,5.69-3.44,5.73-6.6.02-1.51-.54-2.84-1.57-3.74-.83-.72-1.89-1.1-3.05-1.1Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 264.74,
    y: 216.91,
    width: 149.3,
    height: 1.02,
    transform: "translate(-29.16 54.24) rotate(-8.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.43,189.51c-1.2,0-2.3-.4-3.16-1.16-1.07-.95-1.64-2.34-1.59-3.92.1-3.21,2.75-6.22,5.91-6.71l31.03-4.79c1.55-.24,2.96.16,3.97,1.12,1.04.99,1.51,2.45,1.33,4.09-.34,3.17-3.13,6.13-6.21,6.61l-30.4,4.69c-.3.05-.59.07-.87.07ZM301.47,173.89c-.23,0-.46.02-.7.06l-31.03,4.79c-2.69.42-4.95,2.99-5.04,5.73-.04,1.27.4,2.38,1.24,3.12.83.74,1.97,1.04,3.2.85l30.4-4.69c2.65-.41,5.05-2.97,5.35-5.71.14-1.32-.22-2.47-1.02-3.24-.62-.59-1.46-.9-2.4-.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 341.01,
    y: 236.64,
    width: 18.15,
    height: 1.02,
    transform: "translate(-32.04 56.1) rotate(-8.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 366.3,
    y: 232.74,
    width: 18.15,
    height: 1.02,
    transform: "translate(-31.15 59.91) rotate(-8.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 391.58,
    y: 228.84,
    width: 18.15,
    height: 1.02,
    transform: "translate(-30.26 63.72) rotate(-8.76)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrations02);
export default __webpack_public_path__ + "static/media/illustrations-02.9e382cce42bfafe88843999f92fd7a84.svg";
export { ForwardRef as ReactComponent };